import React, { Component, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import getClassNames from 'classnames';
import Card from '../tc-ui/card';
import Icon from '../tc-ui/icon';
import AddItemCard from './add-item-card';

class ProductInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showResults: false,
      moreText: false,
      labelState: true,
    };
  }

  componentDidMount() {
    if (!this.refs.about) return;
    const aboutHeight = findDOMNode(this.refs.about).offsetHeight;
    if (aboutHeight > 126) {
      this.setComponentDisplayStateAfterMount({
        showResults: true,
        moreText: true,
        labelState: true,
      });
    } else {
      this.setComponentDisplayStateAfterMount({
        showResults: false,
        labelState: false,
      });
    }
  }

  setComponentDisplayStateAfterMount = (state) => {
    this.setState(state);
  };

  _addClass = (e) => {
    e.preventDefault();
    this.setState({
      showResults: !this.state.showResults,
      moreText: !this.state.moreText,
    });
  };


  _editDescription = (initialValueSettings) => {
    this.props.editField('productInfo', {
      type: 'productInfo',
      initialValue: initialValueSettings,
      specifiedRoute: 'product',
      isRequired: true,
    });
  };

  _descriptionType() {
    const { routeName } = this.props;
    let descriptionType;
    if (routeName === 'profile') descriptionType = 'Company';
    if (routeName === 'location') descriptionType = 'Location';
    if (routeName === 'product') descriptionType = 'Product';

    return descriptionType;
  }

  render() {
    const { include, exclude, whatToBring } = this.props.productInfo;

    const title = 'Product Information';

    const classes = getClassNames('l-paper-right-info profile-description-paragraph', this.props.className, {
      'short-info': this.state.showResult,
    });

    const label = this.state.moreText ? '+ More' : null;
    const more = this.state.labelState ? label : null;
    let gradient;
    if (this.state.moreText) gradient = <div className="cardGradient" />;

    let descriptionNode;
    let addItemNode;
    let titleBarExtra;
    if (include || exclude || whatToBring) {
      if (this.props.isEditable) {
        titleBarExtra = (
          <div className="profile-edit"
            onClick={this._editDescription.bind(this, {
              include,
              exclude,
              whatToBring,
            })}
          >
            <Icon className="tc-icon-mode_edit profile-edit-icon"/>
            &nbsp;EDIT
           </div>
        );
      }
      descriptionNode = (
        <Card
          className="profile-card"
          title={title}
          companyData="companyData"
          subtitle=""
          titleBarExtra={titleBarExtra}
        >
          <div className={classes} ref="about">
            <div>
              <div className="description-segments">Inclusions</div>
              <div className="l-paper-split-segment">
                {include}
              </div>
            </div>
            <div>
              <div className="description-segments">Exclusions</div>
              <div className="l-paper-split-segment">
                {exclude}
              </div>
            </div>
            <div>
              <div className="description-segments">What To Bring</div>
              <div className="l-paper-split-segment">
                {whatToBring}
              </div>
            </div>
          </div>
           {gradient}
           <a href="#" className="load-more" onClick={this._addClass}> {more} </a>
        </Card>
      );
    } else if (this.props.isEditable) {
      addItemNode = (
        <AddItemCard
          onClick={this._editDescription.bind(this, {
            include,
            exclude,
            whatToBring,
          })}
          text="Add Product Information"
          id="product-info"
        />
      );
    }
    return (
      <div style={{ marginTop: '32px' }} className={this.props.className}>
        {descriptionNode}
        {addItemNode}
      </div>
    );
  }
}

ProductInfo.propTypes = {
  editField: PropTypes.func,
  routeName: PropTypes.string,
  profile: PropTypes.object,
  isEditable: PropTypes.bool,
  className: PropTypes.string,
  productInfo: PropTypes.object,
};

export default ProductInfo;



// WEBPACK FOOTER //
// ./src/app/components/profile/product-info.jsx